import React from 'react';
import PropTypes from 'prop-types';
import TextField from '@mui/material/TextField';
import Form from '../../../common/form/Form';
import validator from '../../../../utils/validator';

export default function ProfileName(props) {
  const { editing, errors, data, onFieldChange, onSubmit } = props;
  return (
    <div>
      { editing &&
        <div className="MemberProfile-itemEdit">
          <Form id='ProfileEditName-form' onSubmit={onSubmit} autoComplete="off" submitLabel='Save'>
            <TextField
              className="FormField-control full"
              name="salutation"
              label="Title (e.g. Mr., Mrs., Dr., etc.)"
              placeholder='Title'
              onChange={onFieldChange}
              helperText={validator.message(errors['salutation'], 'title')}
              error={validator.isDefined(errors['salutation'])}
              value={data.salutation}
              variant="standard"
            />
            <TextField
              className="FormField-control full"
              name="firstName"
              label="First Name"
              placeholder='First Name'
              onChange={onFieldChange}
              helperText={validator.message(errors['firstName'], 'first name')}
              error={validator.isDefined(errors['firstName'])}
              value={data.firstName}
              variant="standard"
            />
            <TextField
              className="FormField-control full"
              name="lastName"
              label="Last Name"
              placeholder='Last Name'
              onChange={onFieldChange}
              helperText={validator.message(errors['lastName'], 'last name')}
              error={validator.isDefined(errors['lastName'])}
              value={data.lastName}
              variant="standard"
            />
          </Form>
        </div>
      }
    </div>
  );
}

ProfileName.defaultProps = {
  editing: false,
  errors: {}
};

ProfileName.propTypes = {
  data: PropTypes.object,
  onFieldChange: PropTypes.func,
  onSubmit: PropTypes.func
};

export function nameFromProfile(data) {
  return { 
    salutation: data.salutation || '', 
    firstName: data.firstName || '', 
    lastName: data.lastName || '',
  };
}

export function formatName(data) {
  const { salutation, firstName, lastName } = data;
  let name = 'No name on record';
  if(firstName) {
    name = salutation? ` ${salutation} ` : ' ';
    name += `${firstName} ${lastName}`;
  }

  return name;
}

export function validateName(data) {
  const validationErrors = validator.validate(data, [
    { rule: validator.rules.MATCHES_PATTERN, prop: 'salutation', against: validator.patterns.SALUTATION, empty: true },
    { rule: validator.rules.MATCHES_PATTERN, prop: 'firstName', against: validator.patterns.NAME, empty: true },
    { rule: validator.rules.IS_DEFINED, prop: 'firstName' },
    { rule: validator.rules.MATCHES_PATTERN, prop: 'lastName', against: validator.patterns.NAME, empty: true },
    { rule: validator.rules.IS_DEFINED, prop: 'lastName' },
  ]);

  return validationErrors? validationErrors : { valid: true };
}
